import { Injectable } from '@angular/core';
import {
    CanActivate,
    Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    CanActivateChild,
    Route
} from '@angular/router';
import { AutenticacaoService } from './autenticacao.service';
import { Mensagem } from '../../environments/resource';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {
    constructor(
        private authService: AutenticacaoService,
        private router: Router
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {
        const url = state.url;
        return this.checkLogin(url);
    }

    canActivateChild(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {
        return this.canActivate(route, state);
    }

    checkLogin(url: string): boolean {
        if (this.authService.logado) {
            return true;
        }

        this.router.navigate(['/pages/login'], { queryParams: { mensagem: Mensagem.sessaoEncerrada } } );
        return false;
    }
}


// WEBPACK FOOTER //
// /app/src/app/services/auth-guard.service.ts